
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export interface UnitOption {
  value: string;
  label: string;
  symbol: string;
  is_default?: boolean;
}

export const useUnitOptions = (companyId?: string) => {
  const [customUnitOptions, setCustomUnitOptions] = useState<UnitOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [optionsReady, setOptionsReady] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    
    const fetchUnits = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .rpc('get_all_units', { user_company_id: companyId })
          .order('is_default', { ascending: false })
          .order('name', { ascending: true });
          
        if (error) throw error;
        
        if (data) {
          const options = data.map(unit => ({
            value: unit.name.toLowerCase().replace(/\s+/g, '_'),
            label: unit.name,
            symbol: unit.symbol,
            is_default: unit.is_default
          }));
          
          setCustomUnitOptions(options);
          setOptionsReady(true);
        }
      } catch (error) {
        console.error('Error loading units:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUnits();
  }, [companyId]);

  return {
    customUnitOptions,
    loading,
    optionsReady
  };
};
